<template>
  <el-dialog
    :model-value="visible"
    :title="translate('Select tiers for the offer')"
    width="640px"
    append-to-body
    :close-on-click-modal="false"
    @update:model-value="onDialogVisible"
    @open="load"
    @closed="unload"
  >
    <div v-for="(entry, entryIndex) in selection" :key="entry.itemId" class="qto-position">
      <div class="qto-title">
        ({{ choices[entryIndex].position }}) {{ choices[entryIndex].name }}<span v-if="choices[entryIndex].externalRefId"> / {{ choices[entryIndex].externalRefId }}</span>
        · {{ choices[entryIndex].quantity }} {{ translate('pcs.') }}
      </div>
      <el-checkbox-group v-model="entry.thresholds">
        <el-checkbox v-for="threshold in choices[entryIndex].thresholds" :key="threshold" :value="threshold">
          {{ threshold }} {{ translate('pcs.') }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <template #footer>
      <el-button @click="cancel">{{ translate('Cancel') }}</el-button>
      <el-button type="primary" @click="confirm">{{ translate('OK') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { defaultOfferTierSelection } from '@/utils/quantityTiersOffer.mjs'

// Which quantity tiers the offer prints as extra rows (spec 8). The tier in force at the
// position's quantity and every tier above it start selected; lower tiers start unchecked.
// OK emits the selection; Cancel, the X and Esc cancel the offer.
export default {
  name: 'CcQuantityTiersOffer',

  emits: ['update:visible', 'confirm', 'cancel'],

  props: {
    visible: { type: Boolean, default: false },
    // offerTierChoices(inquiry) - set by the form before it opens the dialog.
    choices: { type: Array, default: () => [] },
  },

  data() {
    return {
      // Index-aligned with `choices` while open; empty while closed, so a hidden dialog never
      // renders rows for choices that have changed since.
      selection: [],
      settled: false,
    }
  },

  methods: {
    load() {
      this.settled = false
      this.selection = defaultOfferTierSelection(this.choices)
    },

    unload() {
      this.selection = []
    },

    confirm() {
      this.settled = true
      this.$emit('confirm', this.selection)
      this.$emit('update:visible', false)
    },

    cancel() {
      this.settled = true
      this.$emit('cancel')
      this.$emit('update:visible', false)
    },

    // The dialog closing itself - its X or Esc - cancels too.
    onDialogVisible(value) {
      if (!value && !this.settled) {
        this.settled = true
        this.$emit('cancel')
      }
      this.$emit('update:visible', value)
    },
  },
}
</script>

<style scoped>
.qto-position {
  margin-bottom: 14px;
}

.qto-title {
  font-weight: 600;
  margin-bottom: 4px;
}
</style>
